import Spinner from '../spinner/spinner';
import './loader.css';

type LoaderProps = {
	title: string;
	body: string;
};

export const Loader = (props: LoaderProps) => {
	return (
		<div className="loader">
			<div>
				<Spinner />
			</div>
			<div className="loader-content">
				<div className="title">{props.title}</div>
				<div className="body">{props.body}</div>
			</div>
		</div>
	);
};
